import { ExternalLink } from "@octopusdeploy/design-system-components";
import { YouTubePlayer } from "~/components/ContextualHelpLayout/YouTubePlayer";
import { OverviewContainer, OverviewHighlightText } from "../../CommonComponents/CommonViews";
const video = {
    youtubeId: "gfaRUIlQybA",
    shortlink: "OnboardingProjectsVideo",
};
export const ProjectSettingsHelp = () => (<OverviewContainer>
        <OverviewHighlightText>
            <YouTubePlayer videoId={video.youtubeId}/>
            <p>
                <ExternalLink href="OnboardingProjectsLearnMore">Project settings</ExternalLink> allow you to edit details about the project, such as the name, description, and the project group, add a logo and control different aspects of the
                project's release behaviour.
            </p>
        </OverviewHighlightText>
    </OverviewContainer>);
